import { FormArray, FormControl, FormGroup, ValidationErrors, AbstractControl } from '@angular/forms';
import { Utility } from './utility';
import { AjaxService } from '../../services/ajax.service';
import { CountryDataService } from '../../services/country.service';
import { TranslateService } from "@ngx-translate/core";
import * as _ from 'underscore';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomValidators {
  static CHAZ = '\u4E00-\u9FCC\u3400-\u4DB5\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29';
  static JAAZ = '\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\uFF00-\uFFEF\u4E00-\u9FAF\u2605-\u2606\u2190-\u2195\u203B';
  static KOREAN_LETTERS = '\uac00-\ud7af\u1100-\u11ff\u3130-\u318f\ua960-\ua97f\ud7b0-\ud7ff';
  static ACCENTEDLETTERS = 'A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff';
  static SPECIALCHAR = "ÆÐƎƏƐƔĲŊŒẞÞǷȜæðǝəɛɣĳŋœĸſßþƿȝĄƁÇĐƊĘĦĮƘŁØƠŞȘŢȚŦŲƯY̨Ƴąɓçđɗęħįƙłøơşșţțŧųưy̨ƴÁÀÂÄǍĂĀÃÅǺĄÆǼǢƁĆĊĈČÇĎḌĐƊÐÉÈĖÊËĚĔĒĘẸƎƏƐĠĜǦĞĢƔáàâäǎăāãåǻąæǽǣɓćċĉčçďḍđɗðéèėêëěĕēęẹǝəɛġĝǧğģɣĤḤĦIÍÌİÎÏǏĬĪĨĮỊĲĴĶƘĹĻŁĽĿʼNŃN̈ŇÑŅŊÓÒÔÖǑŎŌÕŐỌØǾƠŒĥḥħıíìiîïǐĭīĩįịĳĵķƙĸĺļłľŀŉńn̈ňñņŋóòôöǒŏōõőọøǿơœŔŘŖŚŜŠŞȘṢẞŤŢṬŦÞÚÙÛÜǓŬŪŨŰŮŲỤƯẂẀŴẄǷÝỲŶŸȲỸƳŹŻŽẒŕřŗſśŝšşșṣßťţṭŧþúùûüǔŭūũűůųụưẃẁŵẅƿýỳŷÿȳỹƴźżžẓ";
  static numbers = '0-9';
  static letters = CustomValidators.ACCENTEDLETTERS +
                   CustomValidators.CHAZ +
                   CustomValidators.KOREAN_LETTERS +
                   CustomValidators.JAAZ +
                   CustomValidators.SPECIALCHAR;
  static nameRegex = new RegExp("^([" + CustomValidators.letters + "\\s\\-])*$");
  static address = CustomValidators.letters + CustomValidators.numbers;
  static alphaNum = new RegExp("^([" + CustomValidators.address + "\\s\-])*$");
  static usernameRegex = new RegExp("^[" + CustomValidators.letters+CustomValidators.numbers + "]+(?:[_@.-]?["+CustomValidators.letters+CustomValidators.numbers+"])*$");
  // static emailRegex = /^(?!\-)(?!\_)(?!\.)(?!.*?[-]{2})(?!.*?[_]{2})(?!.*?[.]{2})(([^\"!#$%&'()*+,\/\\;:<\=>?@[\]^`{|}~\"\s]+(\.[^\"!#$%&'()*+,\/\\;:<\=>?@[\]^`{|}~\"\s])*)|(\".+\"))+([^\"_\-!#$%&'()*+.,\/\\;:<\=>?[\]^`{|}~\"\s])@([^\"_\-!#$%&'()*+.,\/\\;:<\=>?[\]^`{|}~\"\s])+(([^\"_!#$%&'()*+.,\/\\;:<\=>?@[\]^`{|}~\"\s])+([^\"_\-!#$%&'()*+.,\/\\;:<\=>?[\]^`{|}~\"\s])+)\.([^\"_\-!#$%&'()*+.,\/\\;:<\=>?@[\]^`{|}~\"\s]{2,})$/
  static emailRegex = /(?=^(?:[A-Za-z0-9_\xC0-\xFF!#$%&'*+\/=?^`{|}~\\-]\.?){0,63}[A-Za-z0-9_\xC0-\xFF!#$%&'*+\/=?^`{|}~\\-]@[A-Za-z0-9\xC0-\xFF](?:[A-Za-z0-9\xC0-\xFF-]{0,61}[A-Za-z0-9\xC0-\xFF])?(?:\.[A-Za-z\xC0-\xFF](?:[A-Za-z0-9\xC0-\xFF-]{0,61}[A-Za-z0-9\xC0-\xFF])?)*$)(?=^.{3,254}$)/;
  static addressRegex = new RegExp("^([" + CustomValidators.address + "#,'\\s\/-])*$");
  static dobRegex = new RegExp("^([" + CustomValidators.numbers + "\\/])*$");
  static thirtyOneDays = [1, 3, 5, 7, 8, 10, 12,'01','03','05','07','08'];
  emailUniqueCheck = 0;
  nicknameUniqueCheck = 0;
  mobileNumberUniqueCheck = 0;
  static translationService: any;
  phoneNumbervalidationInProgress = false;
  constructor(public translationServiceParam: TranslateService) {
    CustomValidators.translationService = translationServiceParam;
  }
  // ﻿^([a-zA-ZA-zÀ-ÖØ-öø-ÿ\
  // u4E00-\u9FCC\u3400-\u4DB5\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29\
  //   u3000-\u303F\u3040-\u309F\u30A0-\u30FF\uFF00-\uFFEF\u4E00-\u9FAF\u2605-\u2606\u2190-\u2195\u203B
  //   ÀÁÂÃÄÅàáâãäåăăĀāąĄÇçćĆčČđĐďĎÈÉÊËèéêëěĚĒēęĘÌÍÎÏìíîïĪīłŁÑñňŇńŃÒÓÔÕÕÖØòóôõöøŌōřŘŠšśŚȘťŤÙÚÛÜùúûüůŮŪūŸÿýÝŽžżŻź0-9\s,'\-#])*$

  static expCardData() {
    return function (control: FormControl) {
      let expMonth; 
      if(control.get('expMonth')){
        expMonth = control.get('expMonth');
      }else if(control.get('expiryMonth')){
        expMonth =control.get('expiryMonth');
      }
      let expYear;
      if(control.get('expYear')){
        expYear = control.get('expYear');
      }else if(control.get('expiryYear')){
        expYear =control.get('expiryYear');
      }

      let regEx = /^[0-9]*$/;
      let date = new Date();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      let message;

      if (!expMonth.value) {
        message = { 'message': CustomValidators.translationService.instant('errors.error10') };
        expMonth.setErrors({ 'message': CustomValidators.translationService.instant('errors.error10') });
      } else if (!regEx.test(expMonth.value)) {
        message = { 'message': CustomValidators.translationService.instant('errors.error12') };
        expMonth.setErrors({ 'message': CustomValidators.translationService.instant('errors.error13') });
      } else if (expMonth.value < 1 || expMonth.value > 12) {
        message = { 'message': CustomValidators.translationService.instant('errors.error12') };
        expMonth.setErrors({ 'message': CustomValidators.translationService.instant('errors.error13') });
      } else if (!expYear.value) {
        message = { 'message': CustomValidators.translationService.instant('errors.error10') };
        expYear.setErrors({ 'message': CustomValidators.translationService.instant('errors.error10') });
      } else if (!regEx.test(expYear.value)) {
        message = { 'message': CustomValidators.translationService.instant('errors.error12') };
        expYear.setErrors({ 'message': CustomValidators.translationService.instant('errors.error14') });
      } else if (expYear.value && (expYear.value).length < 4) {
        message = { 'message': CustomValidators.translationService.instant('errors.error15') };
        expYear.setErrors({ 'message': CustomValidators.translationService.instant('errors.error16') })
      } else if (expYear.value < year) {
        message = { 'message': CustomValidators.translationService.instant('errors.error17') };
        expYear.setErrors({ 'message': CustomValidators.translationService.instant('errors.error14') })
      } else if (expYear.value == year) {
        if (expMonth.value < month) {
          message = { 'message': CustomValidators.translationService.instant('errors.error12') };
          expMonth.setErrors({ 'message': CustomValidators.translationService.instant('errors.error13') })
        } else if (expMonth.value > 12) {
          message = { 'message': CustomValidators.translationService.instant('errors.error12') };
          expMonth.setErrors({ 'message': CustomValidators.translationService.instant('errors.error13') });
        } else {
          expMonth.setErrors(null);
          expYear.setErrors(null);
        }
      } else if (expYear.value > year) {
        expMonth.setErrors(null);
        expYear.setErrors(null);
      }
      return message;
    };
  }
  static creditCardValidator(utils: Utility) {
    return function (control: FormControl) {
      let cardno;
      if(control.get("creditcardNumber")){
        cardno = control.get("creditcardNumber");
      }else if(control.get("cardNumber")){
        cardno = control.get("cardNumber");
      }
      if (cardno.value) {
        const ccNumber = cardno.value.toString().split('-').join('');
        let newCard;
        if(control.get("cardId")){
          newCard = control.get("cardId").value;
        }else if(control.get("accountId")){
          newCard = control.get("accountId").value;;
        }
        let regEx = /^[0-9]*$/;
        let mindigit = 2;
        let message;
        if (newCard === 0) {
          if (!ccNumber) {
            cardno.setErrors({ 'message': CustomValidators.translationService.instant('errors.error10') });
            message = { 'message': CustomValidators.translationService.instant('errors.error10') };
          } else if (ccNumber && !regEx.test(ccNumber)) {
            cardno.setErrors({ 'message': CustomValidators.translationService.instant('errors.error18') });
            message = { 'message': CustomValidators.translationService.instant('errors.error18') };
          } else if (ccNumber && !utils.creditCardValidation(ccNumber)) {
            cardno.setErrors({ 'message': CustomValidators.translationService.instant('errors.error19') });
            message = { 'message': CustomValidators.translationService.instant('errors.error19') };
          } else {
            message = null;
          }
        } else {
          message = null;
        }


        return message;
      } else {
        return "";
      }
    };
  }
  static minValueNumber(minValue, maxValue, fieldName) {

    return function (control: FormControl) {
      let name = control.value;
      let message;
      let regEx = /^[0-9]*(\.\d{0,2})?/;
      minValue = Number(minValue);
      maxValue = Number(maxValue);
      
      if (!name) {
        message = { 'message': CustomValidators.translationService.instant('errors.error10') };
      } else {
        name = Number(name);
        if (!name) {
          message = { 'message': CustomValidators.translationService.instant('errors.error18') };
        } else if (name && !regEx.test(name)) {
          message = { 'message': CustomValidators.translationService.instant('errors.error18') };
        } else if (name && minValue && name < minValue ) {
          if(fieldName === 'withdraw'){
            message = { 'message': CustomValidators.translationService.instant('errors.withdrawlimit') +" "+minValue };
          }else{
            message = { 'message': fieldName+" " + CustomValidators.translationService.instant('errors.error20') + minValue };
          }
        } else if (name && maxValue && name > maxValue) {
          if(minValue > maxValue && fieldName === 'withdraw'){
            message = { 'message': CustomValidators.translationService.instant('errors.maxLimitlessminLimit')};
          }else{
            message = { 'message': fieldName +" "+CustomValidators.translationService.instant('errors.error21') +" "+ maxValue };
          }
        }else {
          message = null;
        }
      }

      return message;
    };
  }

  validatePassword(minChar) {
    let regex = /^(?=.*[a-z])(?=.*\d)[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]+$/;
    return function (control: FormControl) {
      let pwd = '';
      if(control.value){
        pwd = (control.value).trim()
      }
      const password = pwd;
      let message;
      if (!password) {
        message = { 'message': CustomValidators.translationService.instant('errors.error10') };
      } else if (password && password.length < minChar) {
        message = { 'message': CustomValidators.translationService.instant('errors.error22') };
      } 
      // else if (!regex.test(password)) {
      //   message = { 'message': CustomValidators.translationService.instant('errors.error22') };
      // }
       else {
        message = null;
      }
      return message;
    };
  };
  passwordConfirming(c: AbstractControl): { invalid: boolean } {
    let message;

    if (!c.get('password').value) {
      c.get('password').setErrors({ 'message': CustomValidators.translationService.instant('errors.error10') });
      message = { 'message': CustomValidators.translationService.instant('errors.error10') };
    }
    if (!c.get('confirmPassword').value) {
      c.get('confirmPassword').setErrors({ 'message': CustomValidators.translationService.instant('errors.error10') });
      message = { 'message': CustomValidators.translationService.instant('errors.error10') };
    } else if (c.get('confirmPassword').value && c.get('password').value && c.get('password').value !== c.get('confirmPassword').value) {
      c.get('confirmPassword').setErrors({ 'message': CustomValidators.translationService.instant('errors.error23') });
      message = { 'message': CustomValidators.translationService.instant('errors.error23')};
    } else {
      c.get('confirmPassword').setErrors(null);
      message = {};
    }
    return message;
  };

  dobValidator(c: AbstractControl): { invalid: boolean } {
    let message;
    let date = typeof c.get('date').value === 'string' && c.get('date').value ? c.get('date').value.trim() : c.get('date').value;
    let month = typeof c.get('month').value === 'string' && c.get('month').value ? c.get('month').value.trim() : c.get('month').value;
    let year = typeof c.get('year').value === 'string' && c.get('year').value ? c.get('year').value.trim() : c.get('year').value;
    date = parseInt(date);
    month = parseInt(month);
    year = parseInt(year);
    if(date || month || year){
      c.get('date').markAsDirty()
      c.get('month').markAsDirty()
      c.get('year').markAsDirty()
    }
    if (!date) {
      c.get('date').setErrors({ 'message': CustomValidators.translationService.instant('errors.error24') });
      message = { 'message': CustomValidators.translationService.instant('errors.error24') };
      return
    }

    if (!month) {
      c.get('month').setErrors({ 'message': CustomValidators.translationService.instant('errors.error13') });
      message = { 'message': CustomValidators.translationService.instant('errors.error13') };
      return
    }

    if (!year || year < 1900) {
      message = { 'message': CustomValidators.translationService.instant('errors.error14') };
      c.get('date').setErrors(null);
      c.get('month').setErrors(null);
      c.get('year').setErrors(message);
      return
    }

    if (date && month && year) {
      let age = new Date(year + '-' + (month < 10 ? '0' + '' + month : month) + '-' + (date < 10 ? '0' + '' + date : date));
      let ageDifMs = Date.now() - age.getTime();
      let ageDate = new Date(ageDifMs); // miliseconds from epoch 
      c.get('date').setErrors(null);
      c.get('month').setErrors(null);
      c.get('year').setErrors(null);
        let currentDate = new Date();
        let eighteenYearsAgo:any = new Date(currentDate.setFullYear(currentDate.getFullYear()-18));
        let validYear =  eighteenYearsAgo.getFullYear();
        let isInValid = false
        if(date > 31 || date == 0){
          isInValid = true;
          message = { 'message': CustomValidators.translationService.instant('errors.error24') };
          c.get('date').setErrors(message);
        }
        if(month > 12 || month ==0){
          isInValid = true;
          message = { 'message': CustomValidators.translationService.instant('errors.error13') };
          c.get('month').setErrors(message);
        }
        if(year.toString().length != 4 || year == 0){
          isInValid = true;
          message = { 'message': CustomValidators.translationService.instant('errors.error24') };
          c.get('date').setErrors(message);
          c.get('month').setErrors(null);
          c.get('year').setErrors(null);
        }
        if(isInValid){
          return
        }
      if (date === 29 && month === 2 && year % 4 !== 0) {
        //leap year 
        c.get('date').setErrors({ 'message': CustomValidators.translationService.instant('errors.error24')});
        // c.get('month').setErrors({ 'message': CustomValidators.translationService.instant('errors.error13') });
        // c.get('year').setErrors({ 'message': CustomValidators.translationService.instant('errors.error14') });
        message = { 'message': CustomValidators.translationService.instant('errors.error24') };
      } else if (date > 29 && month === 2) {
        c.get('date').setErrors({ 'message': CustomValidators.translationService.instant('errors.error24') });
        // c.get('month').setErrors({ 'message': CustomValidators.translationService.instant('errors.error13') });
        // c.get('year').setErrors({ 'message': CustomValidators.translationService.instant('errors.error14') });
        message = { 'message': CustomValidators.translationService.instant('errors.error24') };
      } else if (date > 30 && !_.contains(CustomValidators.thirtyOneDays, month)) {
        c.get('date').setErrors({ 'message': CustomValidators.translationService.instant('errors.error24') });
        // c.get('month').setErrors({ 'message': CustomValidators.translationService.instant('errors.error13') });
        // c.get('year').setErrors({ 'message': CustomValidators.translationService.instant('errors.error14') });
        message = { 'message': CustomValidators.translationService.instant('errors.error24') };
      } else if (Math.abs(ageDate.getUTCFullYear() - 1970) < 18) {
        c.get('date').setErrors({ 'message': CustomValidators.translationService.instant('errors.error24') });
        c.get('month').setErrors({ 'message': CustomValidators.translationService.instant('errors.error13') });
        c.get('year').setErrors({ 'message': CustomValidators.translationService.instant('errors.error14') });
        message = { 'message': CustomValidators.translationService.instant('errors.error24') };
      } else {
        c.get('date').setErrors(null);
        c.get('month').setErrors(null);
        c.get('year').setErrors(null);
        message = {};
      }
    }
    return message;
  };

  startEndDateCheck(c: AbstractControl): { invalid: boolean } {
    let message;
    const startDate = c.get('startDate').value;
    const endDate = c.get('endDate').value;
    if (!startDate) {
      c.get('startDate').setErrors({ 'invalid': true });
      message = { 'message': CustomValidators.translationService.instant('errors.error10') };
    }
    if (!endDate) {
      c.get('endDate').setErrors({ 'invalid': true });
      message = { 'message': CustomValidators.translationService.instant('errors.error10') };
    }

    if (startDate && endDate && Date.parse(endDate) < Date.parse(startDate)) {
      c.get('endDate').setErrors({ 'message': CustomValidators.translationService.instant('errors.error25') });
      message = { 'message': CustomValidators.translationService.instant('errors.error25') };
    }
    return message;
  };

  validName(minChar, maxChar) {
    return function (control: FormControl) {
      const name = control.value ? control.value.trim() : control.value;
      let hasCat = /_/;
      //CustomValidators.translationService.instant('errors.loginErrors.loginError1');
      let message;
      if (!name) {
        message = { 'message': CustomValidators.translationService.instant('errors.error10') }// CustomValidators.translationService.instant('errors.error10') };
      } else if (name && name.length < minChar) {
        message = { 'message': CustomValidators.translationService.instant('errors.error26') + minChar + CustomValidators.translationService.instant('errors.error55') };
      } else if (name && name.length > maxChar) {
        message = { 'message': CustomValidators.translationService.instant('errors.error26') + maxChar + CustomValidators.translationService.instant('errors.error55') };
      } else if (!CustomValidators.nameRegex.test(name) || hasCat.test(name)) {
        message = { 'message': CustomValidators.translationService.instant('errors.error28') };
      } else {
        message = null;
      }
      return message;
    };
  };

  validAlphaNumeric(minChar, maxChar) {
    return function (control: FormControl) {
      const name = control.value ? control.value.trim() : control.value ;
      let message;
      let regEx = /^[a-z0-9\- ]+$/i;

      if (!name) {
        message = { 'message': CustomValidators.translationService.instant('errors.error10') };
      } else if (!regEx.test(name)) {
        message = { 'message': CustomValidators.translationService.instant('errors.error29') };
      }
      else if (name && name.length < minChar) {
        message = { 'message': CustomValidators.translationService.instant('errors.error26') + minChar + CustomValidators.translationService.instant('errors.error55') };
      } else if (name && maxChar && name.length > maxChar) {
        message = { 'message': CustomValidators.translationService.instant('errors.error30') + maxChar + CustomValidators.translationService.instant('errors.error55') };
      } else {
        message = null;
      }

      return message;
    };
  };
  reqMinMaxNum(minNum, maxChar) {
    return function (control: FormControl) {
      const value = (control.value).toString();
      let message;
      let regEx = /^[0-9]*$/;
      if (!value) {
        message = { 'message': CustomValidators.translationService.instant('errors.error10') };
      } else if (!regEx.test(value)) {
        message = { 'message': CustomValidators.translationService.instant('errors.error18') };
      } else if (value.length < minNum) {
        message = { 'message': CustomValidators.translationService.instant('errors.error26') + minNum + CustomValidators.translationService.instant('errors.error55') };
      } else if (value.length > maxChar) {
        message = { 'message': CustomValidators.translationService.instant('errors.error26') + maxChar + CustomValidators.translationService.instant('errors.error55') };
      } else {
        message = null;
      }

      return message;
    };
  };
  validNumbers(minChar) {
    return function (control: FormControl) {
      const name = control.value;
      let message;
      let regEx = /^[0-9]*$/;

      if (!name) {
        message = { 'message': CustomValidators.translationService.instant('errors.error10') };
      } else if (name && !regEx.test(name)) {
        message = { 'message': CustomValidators.translationService.instant('errors.error18') };
      } else if (name && name.length < minChar) {
        message = { 'message': CustomValidators.translationService.instant('errors.error26') + minChar + CustomValidators.translationService.instant('errors.error55') };
      } else {
        message = null;
      }

      return message;
    };
  };
  
  validateUsername(): any {
    return function (control: FormControl) {
      let regex = /^[a-zA-Z0-9]+(?:[_@.-]?[a-zA-Z0-9])*$/;
      const username = control.value;
      let message;
      if (!username) {
        message = { 'message': CustomValidators.translationService.instant('errors.usernameRequired') };
      } else if (!CustomValidators.usernameRegex.test(username)) {
        message = { 'message': CustomValidators.translationService.instant('errors.usernameError') };
      } else {
        message = null;
      }
      return message;
    };
  };
  minValueNumber(minValue, maxValue, fieldName) {
    return function (control: FormControl) {
      let name = control.value;
      let message;
      let regEx = /^[0-9]*(\.\d{0,2})?/;
      minValue = Number(minValue);
      maxValue = Number(maxValue);
      name = Number(name);
      if (!name) {
        message = { 'message': CustomValidators.translationService.instant('errors.error10') };
      } else if (name && !regEx.test(name)) {
        message = { 'message': CustomValidators.translationService.instant('errors.error18') };
      } else if (name && minValue && name < minValue) {
        message = { 'message': fieldName + CustomValidators.translationService.instant('errors.error20') +" "+minValue };
      } else if (name && maxValue && name > maxValue) {
        message = { 'message': fieldName + CustomValidators.translationService.instant('errors.error21') +" "+ maxValue };
      } else {
        message = null;
      }

      return message;
    };
  };

  exactNumberMatch(value) {
    return function (control: FormControl) {
      const name = control.value;
      let message;
      let regEx = /^[0-9]*$/;
      value = Number(value);
      if (!name) {
        message = { 'message': CustomValidators.translationService.instant('errors.error10') };
      } else if (name && !regEx.test(name)) {
        message = { 'message': CustomValidators.translationService.instant('errors.error18') };
      } else if (name && value && name.length !== value) {
        message = { 'message': CustomValidators.translationService.instant('errors.error31') + value + CustomValidators.translationService.instant('errors.error56') };
      } else {
        message = null;
      }

      return message;
    };
  };

  maxLength(value) {
    return function (control: FormControl) {
      const name = control.value;
      let message;
      value = Number(value);
      if (!name) {
        message = { 'message': CustomValidators.translationService.instant('errors.error10') };
      } else if (name && value && name.length > value) {
        message = { 'message': CustomValidators.translationService.instant('errors.error32') + value + ' characters allowed' };
      } else {
        message = null;
      }

      return message;
    };
  };

  phoneNumberValidator(c: FormControl): ValidationErrors {
    /* If phone / c.value is not there , then toString() on null error is avoided*/
    const phone = c.value?(c.value).toString(): c;
    let regEx = /^[0-9]*$/;
    let mindigit = 5;
    let maxdigit = 15;
    let message;
    if (!phone || phone.length === 0) {
      message = { 'message': CustomValidators.translationService.instant('errors.error10') };
    } else if (phone && !regEx.test(phone)) {
      message = { 'message': CustomValidators.translationService.instant('errors.error33') };
    } else if (phone && phone.length < mindigit) {
      message = { 'message': CustomValidators.translationService.instant('errors.error34') + mindigit + CustomValidators.translationService.instant('errors.error56') };
    } else if (phone && phone.length > maxdigit) {
      message = { 'message': CustomValidators.translationService.instant('errors.error35') + maxdigit + CustomValidators.translationService.instant('errors.error56') };
    } else {
      message = null;
    }

    return message;
  };
  phoneNumberValidatorSE(util?: Utility) {
    /* If phone / c.value is not there , then toString() on null error is avoided*/
    return function(c: FormControl){

      let phone = c.value?(c.value).toString(): c;
      phone = util.trimNumberForSwedenValidation(phone)
      let regEx = /^[0-9]*$/;
      let mindigit = 8;
      let maxdigit = 18;
      let message;
      if (!phone || phone.length === 0) {
        message = { 'message': CustomValidators.translationService.instant('errors.error10') };
      } else if (phone && !regEx.test(phone)) {
        message = { 'message': CustomValidators.translationService.instant('errors.error33') };
      } else if (phone && phone.length < mindigit) {
        message = { 'message': CustomValidators.translationService.instant('errors.error34') + mindigit + CustomValidators.translationService.instant('errors.error56') };
      } else if (phone && phone.length > maxdigit) {
        message = { 'message': CustomValidators.translationService.instant('errors.error35') + maxdigit + CustomValidators.translationService.instant('errors.error56') };
      } else {
        message = null;
      }
      
      return message;
    }
  };
  validateUniqueness(fieldToValidate, ajaxService: AjaxService, validateUnique) {
    let emailUniqueCheck = this.emailUniqueCheck;
    let nicknameUniqueCheck = this.nicknameUniqueCheck;
    return function (control: FormControl) {
      const name = control.value ? control.value.trim() : control.value;
      // var regEx = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

      // let regEx_nickname = /^[\w&.-]+$/;
      let message;
      if (!name) {
        message = { 'message': CustomValidators.translationService.instant('errors.error10') };
      } else if (name && fieldToValidate === "txtEmail" && !CustomValidators.emailRegex.test(name)) {
        message = { 'message': CustomValidators.translationService.instant('errors.error36') };
      } else if (name && fieldToValidate === "txtNickname" && (name.length < 5 || !CustomValidators.usernameRegex.test(name))) {
        message = { 'message': CustomValidators.translationService.instant('errors.error37') };
      } else if (validateUnique) {
        let validateValues = {
          [fieldToValidate]: name
        }
        if (fieldToValidate === "txtEmail") emailUniqueCheck++;
        if (fieldToValidate === "txtNickname") nicknameUniqueCheck++;
        Promise.resolve(ajaxService.validateUniqueness(validateValues))
          .then(uniqueData => {
            if (fieldToValidate === "txtEmail" && --emailUniqueCheck === 0) {
              if (uniqueData && uniqueData["response"] == "1") {
                message = null;
                control.setErrors(null);
              } else {
                if (uniqueData && uniqueData["response"] === 0) {
                  message = { 'message': CustomValidators.translationService.instant('errors.error38') };
                  control.setErrors(message);
                } else {
                  message = { 'message': CustomValidators.translationService.instant('errors.error36') };
                  control.setErrors(message);
                }
              }
            } else if (fieldToValidate === "txtNickname" && --nicknameUniqueCheck === 0) {
              if (uniqueData && uniqueData["response"] == "1") {
                let regex = /^[a-zA-Z0-9]+(?:[_@.-]?[a-zA-Z0-9])*$/;
                const username = control.value;
                if (!username) {
                  message = { 'message': CustomValidators.translationService.instant('errors.usernameRequired') };
                } else if (!CustomValidators.usernameRegex.test(username)) {
                  message = { 'message': CustomValidators.translationService.instant('errors.usernameError') };
                } else {
                  message = null;
                }
                if(message)
                  control.setErrors(message);
              } else {
                message = { 'message': CustomValidators.translationService.instant('errors.error39') };
                control.setErrors(message);
              }
            }

          });

      }

      return message;
    };
  };

  validateSkrillEmail(fieldToValidate) {
    return function (control: FormControl) {
      const name = control.value;
      let message;
      let regEx = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
      if (!name) {
        message = { 'message': CustomValidators.translationService.instant('errors.error10') };
      } else if (name && fieldToValidate === "txtEmail" && !regEx.test(name)) {
        message = { 'message': CustomValidators.translationService.instant('errors.error36') };
      }
      return message;
    };
  }
  validateCheckMobile(ajaxService: AjaxService, validateUnique, profileData, countryDataService? : CountryDataService, utils? : Utility) {
    const country = countryDataService.ipCountry
    let self = this;
    let mobileNumberUniqueCheck = self.mobileNumberUniqueCheck;
    return function (control: AbstractControl) {
      let phoneControl = control.get('phoneNumber') ? control.get('phoneNumber') : control.get('phone');
      let phone = phoneControl ? phoneControl.value : null;
      phone = country == "SE" ? utils.trimNumberForSwedenValidation(phone) : phone
      const areaCode = control.get('areaCode').value;
      let regEx = /^[0-9]*$/;
      let mindigit = country == "SE" ? 8 : 5;
      let maxdigit = country == "SE" ? 18 : 20;
      let message;
      if (!phone || phone.length === 0) {
        message = { 'message': CustomValidators.translationService.instant('errors.error10') };
        phoneControl.setErrors({ 'message': CustomValidators.translationService.instant('errors.error10') });
      } else if (phone && !regEx.test(phone)) {
        message = { 'message': CustomValidators.translationService.instant('errors.error33') };
        phoneControl.setErrors({ 'message': CustomValidators.translationService.instant('errors.error33') });
        // message = { 'message': CustomValidators.translationService.instant('errors.error33') };
      } else if (phone && phone.toString().length < mindigit) {
        //message = { 'message': CustomValidators.translationService.instant('errors.error33') };
        message = { 'message': CustomValidators.translationService.instant('errors.error34') + mindigit + CustomValidators.translationService.instant('errors.error56') };
        phoneControl.setErrors({ 'message': CustomValidators.translationService.instant('errors.error34') + mindigit + CustomValidators.translationService.instant('errors.error56') });
      } else if (phone && phone.toString().length > maxdigit) {
        message = { 'message': CustomValidators.translationService.instant('errors.error35') + maxdigit + CustomValidators.translationService.instant('errors.error56') };
        phoneControl.setErrors({ 'message': CustomValidators.translationService.instant('errors.error35') + maxdigit + CustomValidators.translationService.instant('errors.error56') });
      } else if (validateUnique) {
        if (profileData && profileData.areaCode === areaCode && profileData.phoneNumber === phone) {
          message = null;
          phoneControl.setErrors(null);
        } else if (phone && areaCode) {
          self.phoneNumbervalidationInProgress = true;
          let validateValues = {
            mobileNumber: phone,
            mobileIsdCode: areaCode
          }
          mobileNumberUniqueCheck++;

          Promise.resolve(ajaxService.validateCheckMobile(validateValues))
            .then(uniqueData => {
              if (--mobileNumberUniqueCheck === 0) {
                if (uniqueData && uniqueData["status"] === "SUCCESS") {
                  message = null;
                  phoneControl.setErrors(null);
                } else {
                  message = { 'message': CustomValidators.translationService.instant('errors.error40') };
                  phoneControl.setErrors(message);
                }
              }
              self.phoneNumbervalidationInProgress = false;

            });
        }


      }

      return message;
    };
  };

  static hourMonthVaidator(control: AbstractControl, translationService: TranslateService): { invalid: string } {
    const hour = control.get("hours").value;
    const min = control.get("minutes").value;
    let regEx = /^[0-9]\d*$/;
    let message;
    if ((!hour || hour === "") && (!min || min === "")) {
      message = { 'message': CustomValidators.translationService.instant('errors.error10') };
      control.get("hours").setErrors({ 'message': CustomValidators.translationService.instant('errors.error10') });
      control.get("minutes").setErrors({ 'message': CustomValidators.translationService.instant('errors.error10') });
    } else if ((!hour || hour === "") && (min || min !== "")) {
      message = {};
      control.get("hours").setErrors(null);
      control.get("minutes").setErrors(null);
      if (min < 0 || min > 59) {
        message = { 'message': CustomValidators.translationService.instant('errors.error41') };
        control.get("minutes").setErrors({ 'message': CustomValidators.translationService.instant('errors.error42') });
      }
    } else if ((!min || min === "") && (hour || hour !== "")) {
      message = {};
      control.get("minutes").setErrors(null);
    } else if (min < 0 || min > 59) {
      message = { 'message': CustomValidators.translationService.instant('errors.error41') };
      control.get("minutes").setErrors({ 'message': 'Minutes cannot be more than 60' });
    }

    if (hour && !regEx.test(hour)) {
      message = { 'message': CustomValidators.translationService.instant('errors.error44') };
      control.get("hours").setErrors({ 'message': CustomValidators.translationService.instant('errors.error44') });
    }
    if (min && !regEx.test(min)) {
      message = { 'message': CustomValidators.translationService.instant('errors.error41') };
      control.get("minutes").setErrors({ 'message': CustomValidators.translationService.instant('errors.error41') });
    }

    return message;
  }

  required(c: FormControl): ValidationErrors {
    const value = c.value ? c.value.toString().trim() : c.value;
    let message;
    if (!value || value.length <= 0) {
      message = { 'message': CustomValidators.translationService.instant('errors.error10') };
    } else {
      message = null;
    }

    return message;
  }
  static required(c: FormControl, translationService: TranslateService): ValidationErrors {
    const value =  c.value ? c.value.toString().trim() : c.value;
    let message;
    if (!value || value.length <= 0) {
      message = { 'message': CustomValidators.translationService.instant('errors.error10') };
    } else {
      message = null;
    }
    
    return message;
  }
  validateUserNameEmail(c: FormControl) {
    const value = c.value ? c.value.toString().trim() : c.value;
    let message =null;
    if (!value || value.length <= 0) {
      message = { 'message': CustomValidators.translationService.instant('errors.error10') };
    } else {
      if(!CustomValidators.usernameRegex.test(value) && !CustomValidators.emailRegex.test(value)){
        message = { 'message': CustomValidators.translationService.instant('errors.error29') };
      } else{
        message = null;
      }  
    }
    return message;
  }
  
  addressValidator(isOptional) {
    return function (c: FormControl) {
      const address = c.value ? c.value.trim() : c.value;
      let mindigit = 2;
      let maxdigit = 100;
      let message;
      if (!address && !isOptional) {
        message = { 'message': CustomValidators.translationService.instant('errors.error10') };
      }
      else if (address && address.length < mindigit) {
        message = { 'message': CustomValidators.translationService.instant('errors.error45') };
      } else if (address && address.length > maxdigit) {
        message = { 'message': CustomValidators.translationService.instant('errors.error46') };
      } else if (!CustomValidators.addressRegex.test(address)) {
        message = { 'message': CustomValidators.translationService.instant('errors.error47') };
      } else {
        message = null;
      }

      return message;
    }

  };


  reqMin(minNum) {
    return function (control: FormControl) {
      const value = control.value;
      let message;
      if (!value) {
        message = { 'message': CustomValidators.translationService.instant('errors.error10') };
      } else if (value.length < minNum) {
        message = { 'message': CustomValidators.translationService.instant('errors.error26') + minNum + CustomValidators.translationService.instant('errors.error55') };
        control.setErrors(message);
      }
      else {
        message = null;
      }

      return message;
    };
  };
  static validateDepositAmount(c: AbstractControl, translationService: TranslateService): { invalid: string } {
    let message;
    const period = c.get('limitType').value;
    // const period = c.get('daily').value ? 'daily': c.get('weekly').value ? 'weekly': c.get('monthly').value? 'monthly' :'';
    const daily = Number(c.get('daily').value);
    const weekly = Number(c.get('weekly').value);
    const monthly = Number(c.get('monthly').value);
    switch (period) {
      case 'daily':
        c.get('weekly').setErrors(null);
        c.get('monthly').setErrors(null);
        if (!c.get('daily').value) {
          c.get('daily').setErrors({ 'message': CustomValidators.translationService.instant('errors.error10') });
          message = { 'message': CustomValidators.translationService.instant('errors.error10') };
        } else if (c.get('daily').value === "" || isNaN(daily) || daily < 0) {
          c.get('daily').setErrors({ 'message': CustomValidators.translationService.instant('errors.error18') });
          message = { 'message': CustomValidators.translationService.instant('errors.error10') };
        } else if (weekly > 0 && daily > weekly) {
          c.get('daily').setErrors({ 'message': CustomValidators.translationService.instant('errors.error48') });
          message = { 'message': CustomValidators.translationService.instant('errors.error48') };
        } else if (monthly > 0 && daily > monthly) {
          c.get('daily').setErrors({ 'message': CustomValidators.translationService.instant('errors.error49') });
          message = { 'message': CustomValidators.translationService.instant('errors.error49') };
        }
        break;
      case 'weekly':
        c.get('monthly').setErrors(null);
        c.get('daily').setErrors(null);
        if (!c.get('weekly').value) {
          c.get('weekly').setErrors({ 'message': CustomValidators.translationService.instant('errors.error10') });
          message = { 'message': CustomValidators.translationService.instant('errors.error10') };
        } else if (c.get('weekly').value === "" || isNaN(weekly) || weekly < 0) {
          c.get('weekly').setErrors({ 'message': CustomValidators.translationService.instant('errors.error18') });
          message = { 'message': CustomValidators.translationService.instant('errors.error10') };
        } else if (daily > 0 && daily > weekly) {
          c.get('weekly').setErrors({ 'message': CustomValidators.translationService.instant('errors.error50') });
          message = { 'message': CustomValidators.translationService.instant('errors.error50') };
        } else if (monthly > 0 && weekly > monthly) {
          c.get('weekly').setErrors({ 'message': CustomValidators.translationService.instant('errors.error51') });
          message = { 'message': CustomValidators.translationService.instant('errors.error51') };
        }
        break;
      case 'monthly':
        c.get('daily').setErrors(null);
        c.get('weekly').setErrors(null);
        if (!c.get('monthly').value) {
          c.get('monthly').setErrors({ 'message': CustomValidators.translationService.instant('errors.error10') });
          message = { 'message': CustomValidators.translationService.instant('errors.error10') };
        } else if (c.get('monthly').value === "" || isNaN(monthly) || monthly < 0) {
          c.get('monthly').setErrors({ 'message': 'his field can contain only Numbers' });
          message = { 'message': CustomValidators.translationService.instant('errors.error10') };
        } else if (daily > 0 && daily > monthly) {
          c.get('monthly').setErrors({ 'message': CustomValidators.translationService.instant('errors.error52') });
          message = { 'message': CustomValidators.translationService.instant('errors.error52') };
        } else if (weekly > 0 && weekly > monthly) {
          c.get('monthly').setErrors({ 'message': CustomValidators.translationService.instant('errors.error53') });
          message = { 'message': CustomValidators.translationService.instant('errors.error53') };
        }
        break;
    }
    return message;
  };
  static verifyWireTransfer(c: AbstractControl, translationService: TranslateService): { invalid: boolean } {
    let message;
    let formtype = c.get('formtype').value
    if (!formtype) {
      c.get('accountNumber').setErrors({ 'message': CustomValidators.translationService.instant('errors.error54') });
      message = { 'message': CustomValidators.translationService.instant('errors.error54') };
      c.get('comments').setErrors({ 'message': CustomValidators.translationService.instant('errors.error54') });
      message = { 'message': CustomValidators.translationService.instant('errors.error54') };
      c.get('iban').setErrors({ 'message': CustomValidators.translationService.instant('errors.error54') });
      message = { 'message': CustomValidators.translationService.instant('errors.error54') };
    } else {
      if (formtype === "SEPA") {
        //
        if (!c.get('iban').value) {
          c.get('iban').setErrors({ 'message': CustomValidators.translationService.instant('errors.error10') });
          message = { 'message': CustomValidators.translationService.instant('errors.error10') };
        }
      } else if (formtype === "SWIFT") {
        if (!c.get('accountNumber').value) {
          c.get('accountNumber').setErrors({ 'message': CustomValidators.translationService.instant('errors.error10') });
          message = { 'message': CustomValidators.translationService.instant('errors.error10') };
        }
        if (!c.get('comments').value) {
          c.get('comments').setErrors({ 'message': CustomValidators.translationService.instant('errors.error10') });
          message = { 'message': CustomValidators.translationService.instant('errors.error10') };
        }
      }
    }

    return message;
  };

  validateMultipleCheckboxes(c: AbstractControl ): { invalid: boolean } {
    let message,othersChecked = false,othersval;
    let checked = 0;
    c.setErrors({ 'message': CustomValidators.translationService.instant('errors.selectcheckbox') });
    Object.keys(c["controls"]).forEach(key => {
      const control = c["controls"][key];

        if (control.value === true) checked++;
        
        if( key === "other" && control.value === true){
          othersChecked = true; 
          if(c["controls"]["othersVal"].value){
            othersval = c["controls"]["othersVal"].value.trim();
          }
        }
      });  
     if (checked === 0){
       message = { 'message': CustomValidators.translationService.instant('errors.selectcheckbox') };
       c.setErrors({ 'message': CustomValidators.translationService.instant('errors.selectcheckbox') });
       c.get('othersVal').setErrors(null);
      }
     else if(checked > 0 && !othersChecked ){
       message = null;
       c.setErrors(null);
       c.get('othersVal').setErrors(null);
     }else if (checked > 0 && othersChecked && !othersval) {
      c.get('othersVal').setErrors({ 'message': CustomValidators.translationService.instant('errors.sourceofIncomeTextbox') });
      message = { 'message': CustomValidators.translationService.instant('errors.sourceofIncomeTextbox') };
     } else {
       c.get('othersVal').setErrors(null);
       message = null;
     }

    return message;
  }
}
